import React from 'react';

/**
 * Componente de paginación simplificado para dispositivos móviles.
 * 
 * Muestra un botón "Ver más" que carga la siguiente página, ideal para UX móvil.
 *
 * @param {Object} props
 * @param {number} props.currentPage - Página actual (comenzando desde 0).
 * @param {number} props.total - Total de elementos disponibles.
 * @param {number} props.pageSize - Cantidad de elementos por página.
 * @param {function} props.onPageChange - Función a ejecutar al solicitar la siguiente página.
 */
export default function PaginacionMobile({ currentPage, total, pageSize, onPageChange }) {
  const totalPages = Math.ceil(total / pageSize);
  const isLastPage = currentPage >= totalPages - 1;

  if (totalPages <= 1 || isLastPage) return null; // No mostrar si no hay más páginas

  return (
    <div id="paginacion" className="pagination-area">
      <button 
        type="button" 
        className='showMore-button' 
        onClick={() => onPageChange(currentPage + 1)} 
        disabled={isLastPage}
        aria-label="Cargar más resultados"
      >
        Ver más
      </button>
    </div>
  );
}